export default class ImportFileCode {
}
